import { z } from 'zod';

/** Manzanita.DataModels.OrderCommentStatus */
export type OrderCommentStatus = z.infer<typeof orderCommentStatusSchema>;

/** Manzanita.DataModels.OrderCommentStatus */
export const orderCommentStatusSchema = z.enum(['Sent', 'Received']);

export type OrderStatus =
	| 'InProcess'
	| 'Shipped'
	| 'PartialShipped'
	| 'Backordered'
	| 'OrderReview'
	| 'Rejected'
	| 'Cancelled'
	| 'PartialCancelled'
	| 'Created'
	| 'NewOrder'
	| 'Submitted'
	| 'SubmissionPending'
	| 'OnHold'
	| 'Confirmed'
	| 'Packing';

export type OrderStatusFilter = Exclude<
	OrderStatus,
	'Created' | 'NewOrder' | 'Submitted' | 'SubmissionPending' | 'OnHold' | 'Confirmed' | 'Packing'
>;

export const orderStatusSchema = z.enum([
	'InProcess',
	'Shipped',
	'PartialShipped',
	'Backordered',
	'OrderReview',
	'Rejected',
	'Cancelled',
	'PartialCancelled',
	'Created',
	'NewOrder',
	'Submitted',
	'SubmissionPending',
	'OnHold',
	'Confirmed',
	'Packing',
]) satisfies z.ZodType<OrderStatus>;

export const orderStatusFilterSchema = orderStatusSchema.exclude([
	'Created',
	'NewOrder',
	'Submitted',
	'SubmissionPending',
	'OnHold',
	'Confirmed',
	'Packing',
]) satisfies z.ZodType<OrderStatusFilter>;
